function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M89 56.6C88.2 56.6 87.5 56.1 87.2 55.4L74.6 25.7 47.9 14.7 21.2 25.7 8.8 55.1C8.4 56.1 7.2 56.6 6.2 56.2 5.2 55.8 4.7 54.6 5.1 53.6L18 22.8 47.8 10.5 77.6 22.8 90.8 53.9C91.2 54.9 90.8 56.1 89.7 56.5 89.5 56.5 89.3 56.6 89 56.6Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M48 75.9 32.1 85.6 63.9 85.6Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27 84 44.2 73.6 27 63.1Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.1 61.6 48 71.2 63.9 61.6Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69 84 69 63.1 51.8 73.6Z",
  fill: "currentColor"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 38,
  y: 34.1,
  width: 20,
  height: 12,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72 27.8 47.9 17.6 23.8 27.9 13.1 54.9 13.1 83.6C13.1 84.7 14 85.6 15.1 85.6L23.1 85.6 23.1 59.6C23.1 58.5 24 57.6 25.1 57.6L71.1 57.6C72.2 57.6 73.1 58.5 73.1 59.6L73.1 85.6 81.1 85.6C82.2 85.6 83.1 84.7 83.1 83.6L83.1 54.8 72 27.8ZM62 48.1C62 49.2 61.1 50.1 60 50.1L36 50.1C34.9 50.1 34 49.2 34 48.1L34 32.1C34 31 34.9 30.1 36 30.1L60 30.1C61.1 30.1 62 31 62 32.1L62 48.1Z",
  fill: "currentColor"
})));

var SvgFarm = function SvgFarm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    id: "Icons_Barn",
    overflow: "hidden",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFarm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/farm.aa682f62.svg";
export { ForwardRef as ReactComponent };